import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Modal,
  TextareaAutosize,
  TextField,
} from "@material-ui/core";
import UserSearch from "../UserSearch";
import CourseSearch from "../CourseSearch";
import BlockingReasonSearch from "../BlockingReasonSearch";
import { producaov2 } from "../../../../../services/apis";
import { toast } from "react-toastify";

const validateInputs = ({ user, course, blockingReason, message }) => {
  const values = {
    user,
    course,
    blockingReason,
    message
  }

  const errors = Object.entries(values).reduce((prev, [key, value]) => {
    if(!value) {
      return {
        ...prev,
        hasError: true,
        errors: {
          ...prev.errors,
          [key]: "Campo obrigatório"
        }
      }
    }

    return {
      ...prev,
    }

  }, { hasError: false, errors: {}});

  return errors;
}

export default function CreateAccessBlockingModal({ open, onClose, refreshData = () => {} }) {
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedBlockingReason, setSelectedBlockingReason] = useState(null);
  const [blockingMessage, setBlockingMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleCreateAccessBlocking = async () => {
    const formValidation = validateInputs({ user: selectedUser, course: selectedCourse, blockingReason: selectedBlockingReason, message: blockingMessage });

    if(formValidation.hasError) {
      setErrors(formValidation.errors);
      return;
    }

    setLoading(true);

    try {
      await producaov2.post("/admin/access-blocking", {
        userID: selectedUser?.id,
        courseID: selectedCourse?.id,
        reasonID: selectedBlockingReason?.id,
        message: blockingMessage
      });

      toast.success("Bloqueio criado com sucesso");
      refreshData();
    } catch (error) {
      console.log(error);

      toast.error(`Houve um erro ao criar o bloqueio de acesso. ${error?.response?.data?.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeUser = (user) => {
    if(errors?.user) {
      setErrors(prev => ({...prev, user: ''}));
    }

    setSelectedUser(user)
  }

  const handleChangeCourse = (course) => {
    if(errors?.course) {
      setErrors(prev => ({...prev, course: ''}));
    }

    setSelectedCourse(course)
  }

  const handleChangeReason = (reason) => {
    if(errors?.blockingReason) {
      setErrors(prev => ({...prev, blockingReason: ''}));
    }

    setSelectedBlockingReason(reason)
  }

  const handleChangeMessage = (message) => {
    if(errors?.message) {
      setErrors(prev => ({...prev, message: ''}));
    }

    setBlockingMessage(message)
  }

  return (
    <Dialog fullWidth pad maxWidth="md" open={open} onClose={onClose}>
      <DialogTitle>Criar bloqueio de acesso</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} direction="column">
          <Grid item>
            <UserSearch
              selectedUser={selectedUser}
              onChangeSelectedUser={handleChangeUser}
              errorMessage={errors?.user}
            />
          </Grid>
          <Grid item>
            <CourseSearch
              selectedCourse={selectedCourse}
              onChangeSelectedCourse={handleChangeCourse}
              errorMessage={errors?.course}
            />
          </Grid>
          <Grid item>
            <BlockingReasonSearch
              selectedBlockingReason={selectedBlockingReason}
              onChangeSelectedBlockingReason={handleChangeReason}
              errorMessage={errors?.blockingReason}
            />
          </Grid>
          <Grid item>
            <TextField
              multiline
              fullWidth
              rows={4}
              value={blockingMessage}
              onChange={e => handleChangeMessage(e.target.value)}
              variant="outlined"
              placeholder="Mensagem para o usuário sobre o bloqueio. Ex: Bloqueio de conteúdo por questões financeiras na sua conta"
              error={errors?.message}
              helperText={errors?.message}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions style={{ padding: "1.5rem" }}>
        <Button variant="text" color="secondary" onClick={onClose}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={loading}
          onClick={handleCreateAccessBlocking}
        >{loading ? 'Bloqueando...' : 'Bloquear'}</Button>
      </DialogActions>
    </Dialog>
  );
}
